/**
 * @generated SignedSource<<85026c01436a6e911a180acbf6ab50f6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceRunnerPhase = "BINDING_VOLUME" | "PENDING" | "PREPARING_WORKSPACE" | "READY" | "SCHEDULING_POD" | "STARTING_POD";
import { Url } from "@/common/relayCustomScalar";
export type workspaceRunnerStatusSubscription$variables = {
  id: string;
};
export type workspaceRunnerStatusSubscription$data = {
  readonly workspaceRunnerStatus: {
    readonly phase: WorkspaceRunnerPhase;
    readonly url: Url;
  };
};
export type workspaceRunnerStatusSubscription = {
  response: workspaceRunnerStatusSubscription$data;
  variables: workspaceRunnerStatusSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phase",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "workspaceRunnerStatusSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "WorkspaceRunner",
        "kind": "LinkedField",
        "name": "workspaceRunnerStatus",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "workspaceRunnerStatusSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "WorkspaceRunner",
        "kind": "LinkedField",
        "name": "workspaceRunnerStatus",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6831aaba0edf80d389b1e2481d786172",
    "id": null,
    "metadata": {},
    "name": "workspaceRunnerStatusSubscription",
    "operationKind": "subscription",
    "text": "subscription workspaceRunnerStatusSubscription(\n  $id: ID!\n) {\n  workspaceRunnerStatus(id: $id) {\n    phase\n    url\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d34c9492787540f344d6c32e827d732";

export default node;
